import {
  ApartmentOutlined,
  AuditOutlined,
  ClusterOutlined,
  ContainerOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  IdcardOutlined,
  ReconciliationOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { DashboardCbsIcon, MessagesCbsIcon } from 'assets/svg';
import { AudioLines, Earth } from 'lucide-react';

const RouteList = {
  'incident-management': [
    // {
    //   name_th: 'เรียกคิว',
    //   name_en: 'Queue',
    //   icon: <TeamOutlined />,
    //   path: `/app/incident-management/queue-access`,
    //   query: {
    //     group: 'queue_management',
    //     type: 'คิว',
    //   },
    // },
    {
      name_th: 'รายงาน',
      name_en: 'Report',
      icon: <ReconciliationOutlined style={{ marginRight: 0 }} />,
      path: `/app/incident-management/report`,
      query: {
        group: 'Incident Management',
      },
      children: [
        // {
        //   name_th: 'รายงานประจำวัน',
        //   name_en: 'Daily Report',
        //   icon: <FileDoneOutlined />,
        //   path: '/daily',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานประจำวัน',
        //   },
        // },
        // {
        //   name_th: 'รายงานภายในองค์กร',
        //   name_en: 'Internal Report',
        //   icon: <AuditOutlined />,
        //   path: '/internal',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานภายในองค์กร',
        //   },
        // },
        {
          name_th: 'รายงานแจ้งเหตุออนไลน์',
          name_en: 'Online Incident Report',
          icon: <FileProtectOutlined />,
          path: '/online',
          query: {
            group: 'Incident Management',
            type: 'รายงานการแจ้งเหตุออนไลน์',
          },
        },
        // {
        //   name: 'รายงานจากเว็บฟอร์ม',
        //   icon: <ExceptionOutlined />,
        //   path: '/webform',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานจากเว็บฟอร์ม',
        //   },
        // },
        // {
        //   name: 'รายงานการปฏิบัติหน้าที่',
        //   icon: <SolutionOutlined />,
        //   path: '/onduty',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานการปฏิบัติหน้าที่',
        //   },
        // },
        // {
        //   name: 'รายงานรับแจ้งเหตุ 191',
        //   icon: <FileProtectOutlined />,
        //   path: '/191',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานรับแจ้งเหตุ 191',
        //   },
        // },
      ],
    },
    // {
    //   name: 'ประเภทรายงาน',
    //   icon: <GroupOutlined />,
    //   path: '/app/incident-management/setting/genre',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'ประเภทรายงาน',
    //   },
    // },
    // {
    //   name: 'ตั้งค่าเว็บฟอร์ม',
    //   icon: <SettingOutlined />,
    //   path: '/app/incident-management/setting/webform',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'เว็บฟอร์ม',
    //   },
    // },
    // {
    //   name: 'รหัส ความผิด/เหตุการณ์',
    //   icon: <LockOutlined />,
    //   path: '/app/incident-management/setting/identities-code',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'รหัสความผิด',
    //   },
    // },
    // {
    //   name: "นำเข้าข้อมูล",
    //   icon: <DownloadOutlined />,
    //   path: `/app/incident-management/import-report`,
    //   query: {
    //     group: "incident_management",
    //   },
    // },
  ],
  personnel: [
    {
      name_th: 'กำลังพล',
      name_en: 'Personnel',
      icon: <IdcardOutlined />,
      path: '/app/personnel',
      query: {
        group: 'Personnel',
        type: 'กำลังพล',
      },
    },
    // {
    //   name: 'ตารางปฏิบัติหน้าที่',
    //   icon: <CalendarOutlined />,
    //   path: '/app/personnel/schedule',
    //   query: {
    //     group: 'Personnel',
    //     type: 'ตารางปฏิบัติหน้าที่',
    //   },
    // },
    // {
    //   name: 'ชุดปฏิบัติการ',
    //   icon: <TeamOutlined />,
    //   path: '/app/personnel/team',
    //   query: {
    //     group: 'Personnel',
    //     type: 'ชุดปฏิบัติการ',
    //   },
    // },
    // {
    //   name: 'แผนผังภายในองค์กร',
    //   icon: <ApartmentOutlined />,
    //   path: '/app/personnel/organize-chart',
    //   query: {
    //     group: 'Personnel',
    //     type: 'กำลังพล',
    //   },
    // },
    // {
    //   name: 'นำเข้าข้อมูล',
    //   icon: <DownloadOutlined />,
    //   path: '/app/personnel/import-report-force',
    //   query: {
    //     group: 'Personnel',
    //     type: 'กำลังพล',
    //     name: 'แก้ไขข้อมูลกำลังพล',
    //   },
    // },
    {
      name_th: 'ตั้งค่า',
      name_en: 'Settings',
      icon: <SettingOutlined />,
      path: '/app/personnel/setting',
      query: {
        group: 'Personnel',
        type: ['ตำแหน่ง', 'ฝ่ายงาน'],
      },
      children: [
        {
          name_th: 'ตำแหน่ง',
          name_en: 'Position',
          icon: <ApartmentOutlined />,
          path: '/position',
          query: {
            group: 'Personnel',
            type: 'ตำแหน่ง',
          },
        },
        {
          name_th: 'ฝ่ายงาน',
          name_en: 'Department',
          icon: <ClusterOutlined />,
          path: '/department',
          query: {
            group: 'Personnel',
            type: 'ฝ่ายงาน',
          },
        },
        // {
        //   name: 'องค์กร',
        //   icon: <BankOutlined />,
        //   path: '/organization',
        //   query: {
        //     group: 'Personnel',
        //     type: 'กำลังพล',
        //   },
        // },
      ],
    },
  ],
  poi: [
    {
      name_th: 'แดชบอร์ด',
      name_en: 'Dashboard',
      icon: <IdcardOutlined />,
      path: '/app/poi',
    },
    {
      name_th: 'พื้นที่รับผิดชอบ',
      name_en: 'Responsible Area',
      icon: <IdcardOutlined />,
      path: '/app/poi/place-mornitor',
    },
    {
      name_th: 'ผู้รับผิดชอบแต่ละพื้นที่',
      name_en: 'Area Responsible Person',
      icon: <IdcardOutlined />,
      path: '/app/poi/',
    },
    {
      name_th: 'ข้อมูลสารสนเทศภูมิศาสตร์',
      name_en: 'Geographic Information',
      icon: <IdcardOutlined />,
      path: '/app/poi/',
    },
  ],
  'mass-notification': [
    {
      name_th: 'การแจ้งเตือนมวลชน',
      name_en: 'Mass Notification',
      icon: <AuditOutlined />,
      path: '/app/one-command/mass-notification',
      query: {
        group: 'mass-notification',
      },
    },
    {
      name_th: 'ตั้งค่า',
      name_en: 'Settings',
      icon: <SettingOutlined />,
      path: '/app/one-command/mass-notification',
      query: {
        group: 'mass-notification',
      },
      children: [
        {
          name_th: 'ประเภทการเตือน',
          name_en: 'Alert Type',
          icon: <ContainerOutlined />,
          path: '/setting',
          query: {
            group: 'mass-notification',
          },
        },
      ],
    },
  ],
  cbs: [
    {
      name_th: 'แดชบอร์ด',
      name_en: 'Dashboard',
      icon: (
        <span className="anticon">
          <DashboardCbsIcon width={14} height={14} />
        </span>
      ),
      path: '/app/one-command/cbs',
    },
    {
      name_th: 'รายการข้อความ',
      name_en: 'Message List',
      icon: (
        <span className="anticon">
          <MessagesCbsIcon width={14} height={15} />
        </span>
      ),
      path: '/app/one-command/cbs/list',
    },
    {
      name_th: 'การตั้งค่า',
      name_en: 'Settings',
      icon: <SettingOutlined />,
      path: '/app/one-command/cbs/setting',

      children: [
        {
          name_th: 'ข้อมูลหลัก',
          name_en: 'Master Data',
          icon: <ContainerOutlined />,
          path: '/master-data',
        },
      ],
    },
  ],
  'online-scam': [
    // {
    //   name_th: 'ภาพรวมคดี',
    //   name_en: 'Case Overview',
    //   icon: (
    //     <span className="anticon">
    //       <ChartColumnStacked width={14} height={14} />
    //     </span>
    //   ),
    //   path: '/app/online-scam/dashboard',
    //   query: {
    //     group: 'Online Scam',
    //     // name: '',
    //   },
    // },
    {
      name_th: 'คดีออนไลน์',
      name_en: 'Online Cases',
      icon: (
        <span className="anticon">
          <Earth width={14} height={14} />
        </span>
      ),
      path: '/app/online-scam',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name_th: 'ระบบถอดเสียงการสอบปากคำ',
      name_en: 'Interrogation Transcription System',
      icon: (
        <span className="anticon">
          <AudioLines width={14} height={15} />
        </span>
      ),
      path: '/app/online-scam/voice',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name_th: 'สร้างเอกสาร',
      name_en: 'Create Document',
      icon: <FileTextOutlined />,
      path: '/app/online-scam/document',
      query: {
        group: 'Online Scam',
        // name: '',
      },
      children: [
        {
          name_th: 'รายงานการสืบสวน',
          name_en: 'Investigation Report',
          icon: <FileTextOutlined />,
          path: '/investigation',
        },
        {
          name_th: 'หมายเรียกพยาน',
          name_en: 'Witness Report',
          icon: <FileTextOutlined />,
          path: '/witness',
        },
      ],
    },
  ],
};

export default RouteList;
